import { render, staticRenderFns } from "./upgrade_test_add.vue?vue&type=template&id=4bf9c108&scoped=true&"
import script from "./upgrade_test_add.vue?vue&type=script&lang=js&"
export * from "./upgrade_test_add.vue?vue&type=script&lang=js&"
import style0 from "./upgrade_test_add.vue?vue&type=style&index=0&id=4bf9c108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9c108",
  null
  
)

export default component.exports